import React, { useEffect } from "react";
import { Api_Url } from "../../../utils/ApiUrl";
import { toast } from 'react-toastify'; // Import the toast function
import Loader from "../../../hooks/loader";
import { use } from "react";

export function Premium({ userDel, setUserDel, setPreData }) {
    const [loader, setLoader] = React.useState(false);
    const [isChecked, setIsChecked] = React.useState(false);
    console.log(userDel, 'userDel?.UserPremiumPlan');
    const handlePremiumToggle = async (event) => {
        // const isChecked = event.target.checked;
        const userId = userDel?._id;
      

        if (!userId) {
            toast.error("User ID is missing!");
            return;
        }

        const requestBody = {
            id: userId,
            walletAddress: userDel?.walletAddress,
            accessCode: userDel?.accessCode,
            // isPremium: isChecked,
        };

        try {
            setLoader(true)
            const response = await fetch(`${Api_Url}/users/admin/set-premium`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('accessToken') }`,
                },
                body: JSON.stringify(requestBody),
            });

            if (response.ok) {
                let premiumRes = await response.json();
                premiumRes = premiumRes?.data?.data;
                const updatedUserDel = { ...userDel, UserPremiumPlan: premiumRes?.isPremium };
                if (setUserDel) {
                    setUserDel(updatedUserDel); // Update parent with the manually toggled object
                }
                // console.log(updatedUser?.data?.data, 'response');
                
                setPreData(premiumRes)
              setTimeout(() => {
                  setLoader(false)
                  toast.success('Premium status updated successfully!');
              }, 3000);
               
               
            } else {
                setLoader(false)
                const errorData = await response.json(); // Try to get more specific error info
                toast.error(`Failed to update premium status: ${errorData?.message || response.statusText}`);
                console.error("Failed to update premium status:", response.status, errorData);
                // Optionally, revert the toggle state in the UI if the API call fails
            }
        } catch (error) {
            setLoader(false)
            toast.error(`Error updating premium status: ${error.message}`);
            console.error("Error updating premium status:", error);
            // Optionally, revert the toggle state in the UI if there's a network error
        }
    };
useEffect(() => {
    // Check if userDel is defined and has UserPremiumPlan property
    if (userDel) {
    const isPremium = userDel?.UserPremiumPlan;
    setIsChecked(isPremium);
    }
}
, [userDel]);
    return (
        <>
            {loader ? <Loader /> : <></>}
        <div className="set-custom-claim-text d-none">
            <div className="parent-toggle-switch-custom ">
                <div className="custom-toggle">
                    <input
                        type="checkbox"
                        className="checkbox"
                            id="checkboxess"
                        checked={isChecked}
                            disabled={userDel?.UserPremiumPlan}
                        onChange={handlePremiumToggle}
                    />
                    <label className="switch " htmlFor="checkboxess">
                        <span className="slider"></span>
                    </label>
                </div>
            </div>
            <h6>
                {userDel?.UserPremiumPlan ? "Disable" : "Enable"} Premium
            </h6>
        </div>
        </>
    );
}